import { render } from "./Top.vue?vue&type=template&id=4034aa7f&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "./Top.vue?vue&type=style&index=0&id=4034aa7f&scoped=true&lang=css"

import exportComponent from "/Users/macbookair/Documents/Software Chelita/BAESA/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4034aa7f"]])

export default __exports__